import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { id: "container" }
const _hoisted_3 = { id: "main-content-port" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = {
  key: 0,
  class: "kakugo w100",
  style: {"height":"160px","top":"0","z-index":"10"}
}
const _hoisted_6 = {
  class: "ofh w80 fl",
  style: {"margin-top":"25px"}
}
const _hoisted_7 = {
  class: "fs24 ls1 fl fw600",
  style: {"margin-left":"80px","margin-top":"24px"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "fl" }, "レポート", -1)
const _hoisted_9 = {
  key: 0,
  class: "fl arial"
}
const _hoisted_10 = {
  key: 0,
  class: "fl arial ml40 mt15"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", {
  class: "fs10 centered",
  style: {"line-height":"14px","margin-bottom":"0"}
}, "SMS送信件数", -1)
const _hoisted_12 = {
  class: "fs28 fw600",
  style: {"margin-left":"12px"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "dgrey ls2 fs16" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "fs11",
    style: {"margin-left":"-4px"}
  }, " "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "fs11",
    style: {"margin-left":"-6px"}
  }, "通")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", {
  class: "fl",
  style: {"margin-left":"80px"}
}, "※ 確定数順、()内は前月", -1)
const _hoisted_16 = {
  class: /*#__PURE__*/_normalizeClass(`fr circle_button fw600 centered fs12 blueAround`),
  style: {"width":"220px","padding":"4px 10px","margin-top":"30px","border":"0"}
}
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", {
  class: "fw600 fl",
  style: {"margin-bottom":"0"}
}, "  進捗管理画面に切り替え", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = {
  class: "w100",
  style: {
                            height: `40px`,
                            textAlign: `center`,
                            borderBottom: `1px solid #ddd`,
                            minWidth: `1200px`,
                        }
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_23 = {
  key: 1,
  class: "w100"
}
const _hoisted_24 = {
  key: 0,
  class: ""
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  class: "centered",
  style: {"margin-top":"100px"}
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "今月の確定件数がありません。", -1)
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 2,
  class: "w100 roomTableContentWrapper"
}
const _hoisted_30 = { class: "w100 roomTableContent" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("tr", {
  style: {"line-height":"20px"},
  class: "llgreyBg"
}, [
  /*#__PURE__*/_createElementVNode("th", {
    width: "160",
    class: "fs11 centered"
  }, "ユーザー名"),
  /*#__PURE__*/_createElementVNode("th", { class: "centered fs11" }, [
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("div", {
        class: "fl",
        style: {"width":"110px"}
      }, [
        /*#__PURE__*/_createTextVNode(" 日程調整 "),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("開始数 ")
      ]),
      /*#__PURE__*/_createElementVNode("div", {
        class: "fl mt6",
        style: {"width":"70px"}
      }, "前月比"),
      /*#__PURE__*/_createElementVNode("div", {
        class: "fl",
        style: {"width":"130px"}
      }, [
        /*#__PURE__*/_createTextVNode(" 日程調整 "),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("確定数 ")
      ]),
      /*#__PURE__*/_createElementVNode("div", {
        class: "fl mt6",
        style: {"width":"70px"}
      }, "前月比"),
      /*#__PURE__*/_createElementVNode("div", {
        class: "fl mt6",
        style: {"width":"90px"}
      }, "確定率"),
      /*#__PURE__*/_createElementVNode("div", {
        class: "fl mt6",
        style: {"width":"70px"}
      }, "前月比"),
      /*#__PURE__*/_createElementVNode("div", {
        class: "fl",
        style: {"width":"120px"}
      }, [
        /*#__PURE__*/_createTextVNode(" 確定から開催までの "),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("平均日数 ")
      ]),
      /*#__PURE__*/_createElementVNode("div", {
        class: "fl mt6",
        style: {"width":"70px"}
      }, "前月比"),
      /*#__PURE__*/_createElementVNode("div", {
        class: "fl",
        style: {"width":"130px"}
      }, [
        /*#__PURE__*/_createTextVNode(" コミュニ "),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("ケーション数 ")
      ]),
      /*#__PURE__*/_createElementVNode("div", {
        class: "fl mt6",
        style: {"width":"70px"}
      }, "前月比")
    ])
  ])
], -1)
const _hoisted_32 = {
  key: 2,
  class: "w100"
}
const _hoisted_33 = {
  key: 0,
  class: ""
}
const _hoisted_34 = { key: 1 }
const _hoisted_35 = {
  class: "centered",
  style: {"margin-top":"100px"}
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "確定件数がありません。", -1)
const _hoisted_37 = ["src"]
const _hoisted_38 = {
  key: 2,
  class: "w100 roomTableContentWrapper"
}
const _hoisted_39 = { class: "w100 roomTableContent" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("tr", {
  style: {"line-height":"20px"},
  class: "llgreyBg"
}, [
  /*#__PURE__*/_createElementVNode("th", {
    width: "160",
    class: "fs11 centered"
  }, " "),
  /*#__PURE__*/_createElementVNode("th", { class: "centered fs11" }, [
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("div", {
        class: "fl pad8 fs12",
        style: {"width":"110px"}
      }, "開始数"),
      /*#__PURE__*/_createElementVNode("div", {
        class: "fl pad8 fs12",
        style: {"width":"130px"}
      }, "確定数"),
      /*#__PURE__*/_createElementVNode("div", {
        class: "fl pad8 fs12",
        style: {"width":"130px"}
      }, "キャンセル数")
    ])
  ])
], -1)
const _hoisted_41 = { class: "roomTableTr" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("td", {
  class: /*#__PURE__*/_normalizeClass(`roomTableTd centered fw600 fs20 lskyblueBg`)
}, "全体", -1)
const _hoisted_43 = {
  class: /*#__PURE__*/_normalizeClass(`posRe ${`lskyblueBg`}`)
}
const _hoisted_44 = {
  class: "fl centered",
  style: {"width":"110px"}
}
const _hoisted_45 = { class: "fw600 arial fs24" }
const _hoisted_46 = {
  class: "fl centered",
  style: {"width":"130px"}
}
const _hoisted_47 = { class: "fw600 arial fs24" }
const _hoisted_48 = {
  class: "fl centered",
  style: {"width":"130px"}
}
const _hoisted_49 = { class: "fw600 arial fs24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress_bar = _resolveComponent("vue3-progress-bar")!
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_ChukaiSidebarMenu = _resolveComponent("ChukaiSidebarMenu")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_RoomsLoader = _resolveComponent("RoomsLoader")!
  const _component_ReportStatCell = _resolveComponent("ReportStatCell")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue3_progress_bar),
    _createVNode(_component_FlashNotice),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_ChukaiSidebarMenu, { currentPage: `reports` }),
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("section", _hoisted_4, [
          (!_ctx.isSP)
            ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h4", _hoisted_7, [
                    _hoisted_8,
                    (_ctx.repoDate)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, "【" + _toDisplayString(_ctx.repoDate.year) + "年" + _toDisplayString(_ctx.repoDate.month) + "月度】", 1))
                      : _createCommentVNode("", true),
                    (_ctx.repoDate)
                      ? (_openBlock(), _createBlock(_component_SelectTag, {
                          key: 1,
                          name: "span_repo_months",
                          id: "select_repo_months",
                          class: "fl fs14 roundForm mr5",
                          style: {"min-width":"50px","height":"50px","margin-top":"-10px"},
                          options: _ctx.selectMonths,
                          defaultOption: `${_ctx.repoDate.month}月`,
                          needUnselect: false,
                          onSelectValue: _ctx.selectMonth
                        }, null, 8, ["options", "defaultOption", "onSelectValue"]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.repo && _ctx.repo.sm_report && _ctx.repo.sm_report.total_send_num)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.repo.sm_report.total_send_num), 1),
                        _hoisted_13
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_14,
                  _hoisted_15
                ]),
                (_ctx.UserPermissionsOption.permitDisplay(_ctx.rm.userInfo, `reports`, `progresses`))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: "/progresses"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("label", _hoisted_16, [
                          _createElementVNode("img", {
                            src: _ctx.$getAssetImageUrl(`/assets/icons/three.png`),
                            width: "17",
                            height: "16",
                            style: {"margin-top":"1px"},
                            class: "fl"
                          }, null, 8, _hoisted_17),
                          _hoisted_18
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _hoisted_19
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("section", _hoisted_20, [
            _createElementVNode("div", {
              class: _normalizeClass(`roomsCategoryTab categoryFixed pointer centered fl small pad8 ${
                                _ctx.selectedTabName == 'parent_room' ? 'selected fw600' : ''
                            }`),
              style: {"width":"140px","line-height":"24px"},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectCategoryTab('parent_room')))
            }, " 調整ページ ", 2),
            _createElementVNode("div", {
              class: _normalizeClass(`roomsCategoryTab categoryFixed pointer centered fl pad8 small ${
                                _ctx.selectedTabName == 'parent_room_group' ? 'selected fw600 ' : ''
                            }`),
              style: {"width":"140px","line-height":"24px"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectCategoryTab('parent_room_group')))
            }, " ステップ調整 ", 2),
            _hoisted_21
          ]),
          _hoisted_22,
          (_ctx.selectedTabName == 'parent_room')
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                (!_ctx.repo)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_24, [
                      _createVNode(_component_RoomsLoader)
                    ]))
                  : (_ctx.repo.users_stats.length == 0)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _hoisted_27,
                          _createElementVNode("img", {
                            src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                            width: "40",
                            height: "40"
                          }, null, 8, _hoisted_28)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("section", _hoisted_29, [
                        _createElementVNode("table", _hoisted_30, [
                          _hoisted_31,
                          _createVNode(_component_ReportStatCell, {
                            stat: _ctx.repo.total_stats,
                            type: `all`
                          }, null, 8, ["stat"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.repo.users_stats, (stat, statindex) => {
                            return (_openBlock(), _createBlock(_component_ReportStatCell, {
                              stat: stat,
                              type: `user`,
                              openReportUserIds: _ctx.openReportUserIds,
                              key: `${stat.parents}-${statindex}`,
                              onToggleDetail: _ctx.toggleDetail
                            }, null, 8, ["stat", "openReportUserIds", "onToggleDetail"]))
                          }), 128))
                        ])
                      ]))
              ]))
            : _createCommentVNode("", true),
          (_ctx.selectedTabName == 'parent_room_group')
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                (!_ctx.pargRepo)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_33, [
                      _createVNode(_component_RoomsLoader)
                    ]))
                  : (_ctx.pargRepo.total_stats.pargs.length == 0)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _hoisted_36,
                          _createElementVNode("img", {
                            src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                            width: "40",
                            height: "40"
                          }, null, 8, _hoisted_37)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("section", _hoisted_38, [
                        _createElementVNode("table", _hoisted_39, [
                          _hoisted_40,
                          _createElementVNode("tr", _hoisted_41, [
                            _hoisted_42,
                            _createElementVNode("td", _hoisted_43, [
                              _createElementVNode("div", _hoisted_44, [
                                _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.pargRepo.total_stats.pargs.length), 1)
                              ]),
                              _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.pargRepo.total_stats.fixed_pargs.length), 1)
                              ]),
                              _createElementVNode("div", _hoisted_48, [
                                _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.pargRepo.total_stats.closed_pargs.length), 1)
                              ])
                            ])
                          ])
                        ])
                      ]))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}